export default {"src":"/_next/static/media/environmentally.fac5d2c2.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};